import { useTranslate } from '@va/localization';
import { Button, GrayGradientDivider, Paragraph } from '@va/ui/design-system';
import { CreationSteps, useCustomTrackingCodeDomainCreationCtx } from '../custom-tracking-code-domain-creation-context';

export const ConfirmEffectsStep = () => {
  const translate = useTranslate();
  const { setActiveStep, saveCustomDomain, domain } = useCustomTrackingCodeDomainCreationCtx();

  return (
    <div>
      <Paragraph className='p-4'>
        {translate('standalone.customDomains.trackingCode.confirmDomainChange.line2', { newDomain: domain })}
      </Paragraph>

      <GrayGradientDivider />

      <div className='flex flex-row justify-end p-3 gap-3'>
        <Button
          className='rounded-12 flex-1'
          color='tertiary'
          text={translate('button.back')}
          onClick={() => {
            setActiveStep(CreationSteps.verifyDNS);
          }}
        />
        <Button
          className='rounded-12 flex-2 '
          color='primary'
          text={translate('button.confirmAndSaveChanges')}
          onClick={saveCustomDomain}
        />
      </div>
    </div>
  );
};
